import React from "react"
import PropTypes from "prop-types"
import { createGlobalStyle } from "styled-components"
import AnnouncementBar from "./announcementBar"
import Navbar from "../components/globals/navbar/Navbar"
import Footer from "../components/globals/Footer"
import Newsletter from "../components/globals/Newsletter"
import { colors } from "../utils/styles"
import { Helmet } from "react-helmet"
import Restaurant from "./restaurantContext"
import { RestaurantContext } from "./restaurantContext"

const Layout = ({ children, ...props }) => {
  return (
    <Restaurant>
      <React.Fragment>
        <Helmet>
          <style>
            @import
            url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;700&family=Courgette&display=swap');
          </style>
        </Helmet>
        <RestaurantContext.Consumer>
          {({ temporarilyClosed }) => {
            return <GlobalStyle temporarilyClosed={temporarilyClosed} />
          }}
        </RestaurantContext.Consumer>
        <AnnouncementBar />
        <Navbar {...props.header} />
        {children}
        <Newsletter />
        <Footer />
      </React.Fragment>
    </Restaurant>
  )
}

const GlobalStyle = createGlobalStyle`

  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
    --announcement-bar-height: ${props =>
      props.temporarilyClosed ? `3.5rem` : `0`};
  }

  *, ::after, ::before {
    box-sizing: border-box;
  }

  body {
    background-color: ${colors.mainWhite};
    color: ${colors.mainBlack};
    margin: 0;
    font-family: 'Barlow', sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
  }

  article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
    display: block;
  }

  address {
    font-style: normal;
  }

  a {
    text-decoration: none;
  }

  h1, h2, h3, h4, h5 {
    margin-bottom: 0.5rem;
    margin-top: 0;
  }

  p {
    margin-bottom: 1rem;
    margin-top: 0;
  }

  h1 {
    font-family: 'Courgette', cursive;
    text-wrap: balance;
  }
`

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
